import { useQuery } from '@tanstack/vue-query'
import { useQueryParams } from './api-utils'
import { retryOnFailures } from '~/utils/query'

export function useCheckPriceFinalQuery(
  code: MaybeRefOrGetter<string>,
  trip: MaybeRefOrGetter<Partial<TripParams>>,
) {
  const fetch = useRequestFetch()

  const confData = useConfdata()
  const partner = usePartner()

  const params = useQueryParams(() => ({
    accommodation: toValue(code),
    checkin: toValue(trip).checkin,
    checkout: toValue(trip).checkout,
    adults: toValue(trip).pax,
    salesoffice: confData.salesoffice?.code,
    language: confData.language,
    currency: confData.currency,
    partnerId: partner.id,
  }))

  return useQuery({
    enabled: computed(() => isTripValid(toValue(trip))),
    queryKey: ['check-price-final', params] as const,
    queryFn({ queryKey: [, query] }) {
      return fetch<CheckPrice>('/webcc-api/v1/booking/checkPrice/final', {
        query,
        headers: removeFalsy({ jwt: partner.jwt }),
      })
    },
    retry: retryOnFailures(),
  })
}
